"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var Title = function Title(_ref) {
  var title = _ref.title,
      postTitleIconClass = _ref.postTitleIconClass;

  var parsedTitle = _htmlParser.default.stripHtml(title);

  return (0, _preact.h)("h2", {
    className: "search-result-title"
  }, parsedTitle, postTitleIconClass && (0, _preact.h)("i", {
    className: (0, _classnames.default)('search-result-title-post-icon', postTitleIconClass),
    "aria-hidden": "true"
  }));
};

var _default = Title;
exports.default = _default;